
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.136 7.499l3.599-3.316a.48.48 0 000-.727L12.136.14c-.196-.19-.469-.185-.636.005-.168.19-.139.464.053.645l3.282 3.027-3.282 3.032c-.192.181-.22.454-.053.645.167.19.44.19.636.005zm-8.374.005c.2.185.469.18.636-.01.167-.19.144-.459-.048-.64L1.068 3.822 4.35.79c.192-.18.215-.45.048-.645-.167-.19-.435-.19-.636-.005L.163 3.456a.487.487 0 000 .727l3.599 3.32zM5.374 6.06c.348 0 .64-.284.64-.639a.643.643 0 00-.64-.636.64.64 0 00-.64.636c0 .355.288.64.64.64zM7.923 6.06c.348 0 .639-.284.639-.639a.643.643 0 00-.64-.636.64.64 0 00-.638.636c0 .355.287.64.639.64zM10.472 6.06c.348 0 .639-.284.639-.639a.642.642 0 00-.64-.636.64.64 0 00-.639.636c0 .355.288.64.64.64z","fill":"#000"}})])
          )
        }
      }
    